export default {
  init() {
    // JavaScript to be fired on all pages
    $('.breadcrumb-anchor').each((i, anchor) => {
      const $anchor = $(anchor),
            anchorName = $anchor.attr('name'),
            addBreadcrumb = $anchor.data('breadcrumb'),
            breadcrumbTitle = $anchor.data('breadcrumb-title');

      if (addBreadcrumb) {
        const breadcrumb = '<li><a class="nav-link" href="#' + anchorName + '" title="' + breadcrumbTitle + '"></a></li>';
        $('.breadcrumbs ul').append(breadcrumb);
      }
    });

    $('[data-spy="scroll"]').each((i, scrollspy) => {
      $(scrollspy).scrollspy('refresh');
    });

    $('body').on('mouseenter', '.breadcrumbs .nav-link', (e) => {
      const anchorTarget = $(e.target).attr('href'),
            $breadcrumbs = $('.breadcrumbs .nav-link[href="' + anchorTarget + '"]');

      $breadcrumbs.addClass('hover');
    });

    $('body').on('mouseleave', '.breadcrumbs .nav-link', (e) => {
      const anchorTarget = $(e.target).attr('href'),
            $breadcrumbs = $('.breadcrumbs .nav-link[href="' + anchorTarget + '"]');

      $breadcrumbs.removeClass('hover');
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/components/breadcrumbs.js